import './App.css';
import './routes';
import AppRoutes from './routes';
import { ThemeProvider, CssBaseline, Container, Typography } from '@mui/material';
import theme from './theme';


const App = () => {

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline /> 
      <Container>
       <AppRoutes/>
       </Container>
       </ThemeProvider>

  )
}

export default App;
